// 하트 아이템 클래스 - 생명력 회복
class Heart extends Item {
  constructor(scene, x = 0, z = 0) {
    super(scene, x, z);

    // 하트 아이템 설정
    this.modelPath = ItemConfig.HEART.MODEL_PATH;
    this.healAmount = ItemConfig.HEART.HEAL_AMOUNT; // 회복량
  }

  // 하트 아이템 효과 적용
  applyEffect(player) {
    if (!player) return;

    // 플레이어 체력 회복
    const oldHealth = player.health;
    player.health = Math.min(player.health + this.healAmount, player.maxHealth);
    const actualHeal = player.health - oldHealth;

    // 체력바 업데이트 (있는 경우)
    if (player.healthBar) {
      player.healthBar.updateHealth(player.health, player.maxHealth);
    }

    Utils.log(
      `💖 하트 아이템으로 ${actualHeal}만큼 회복! (현재 체력: ${player.health}/${player.maxHealth})`
    );

    // 동료들도 체력 회복
    if (this.companionManager && this.companionManager.companions) {
      this.companionManager.companions.forEach((companion) => {
        if (companion.isAlive) {
          const oldCompanionHealth = companion.health;
          companion.health = Math.min(
            companion.health + this.healAmount,
            companion.maxHealth
          );
          const actualCompanionHeal = companion.health - oldCompanionHealth;

          // 동료 체력바 업데이트
          if (companion.healthBar) {
            companion.healthBar.updateHealth(
              companion.health,
              companion.maxHealth
            );
          }
        }
      });
    }
  }

  // 하트만의 발광 효과 (분홍빛/빨간빛)
  // applyCollectionGlow(child, progress) {
  //   // 빨간색에서 분홍색으로 변하는 발광 효과
  //   const redIntensity = Math.floor(0x880000 + 0x770000 * progress);
  //   const greenIntensity = Math.floor(0x220000 + 0x440000 * progress);
  //   const blueIntensity = Math.floor(0x220000 + 0x440000 * progress);
  //   const glowColor =
  //     (redIntensity << 16) | (greenIntensity << 8) | blueIntensity;
  //   child.material.emissive.setHex(glowColor);
  // }

  // 수집 효과 연출
  playCollectionEffect() {
    // 파티클 효과나 사운드 효과를 여기에 구현
    // 현재는 로그만 출력
    // Utils.log("💖 하트 수집 효과!");

    if (this.collectedPlayer) {
      this.applyEffect(this.collectedPlayer);
    }
  }
}

// webpack 빌드를 위해 default export 추가
export default Heart;

// 전역 변수로도 등록 (기존 코드 호환성)
window.Heart = Heart;